import { render, staticRenderFns } from "./TicketCardComment.vue?vue&type=template&id=65fcd7dc&"
import script from "./TicketCardComment.vue?vue&type=script&lang=js&"
export * from "./TicketCardComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports